import React from 'react';


const ShowValidationMessage = ({

   className = 'mt-1 text-sm text-red-600', 
   error
}) => {

    return (
        error && (
            <p className={className}>{error}</p>
        )
    );

};

export default ShowValidationMessage;